<template>
    <div>
        <div class="container-fluid">

            <div class="pop-holder d-none" >
                <div class="row">
                    <div class="col-md-8">
                        <!-- <h6>1 New Property Assigned</h6> -->
                        <div class="left-hand">
                            <!-- <img src="../assets/icons/request.svg" alt="request"> -->
                            <span>
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.02" y="0.02" width="43.96" height="43.96" rx="21.98" fill="white"/>
                                <rect x="0.02" y="0.02" width="43.96" height="43.96" rx="21.98" stroke="#E5E7EB" stroke-width="0.04"/>
                                <path d="M13.75 26.875H16.75V28.75H13.75V26.875Z" fill="black"/>
                                <path d="M32.125 16.0019H29.95C30.1763 15.5249 30.2791 14.9987 30.2489 14.4716C30.2187 13.9445 30.0566 13.4334 29.7773 12.9853C29.498 12.5373 29.1106 12.1666 28.6506 11.9074C28.1907 11.6482 27.6729 11.5088 27.145 11.5019C25.5893 11.4639 24.0737 11.9976 22.885 13.0019C22.5471 13.2965 22.2495 13.6345 22 14.0069C21.7505 13.6345 21.4529 13.2965 21.115 13.0019C19.9263 11.9976 18.4107 11.4639 16.855 11.5019C16.3271 11.5088 15.8093 11.6482 15.3494 11.9074C14.8894 12.1666 14.502 12.5373 14.2227 12.9853C13.9434 13.4334 13.7813 13.9445 13.7511 14.4716C13.7209 14.9987 13.8237 15.5249 14.05 16.0019H11.875C11.3777 16.0019 10.9008 16.1994 10.5492 16.5511C10.1975 16.9027 10 17.3796 10 17.8769V30.6269C10 31.1242 10.1975 31.6011 10.5492 31.9527C10.9008 32.3044 11.3777 32.5019 11.875 32.5019H32.125C32.6223 32.5019 33.0992 32.3044 33.4508 31.9527C33.8025 31.6011 34 31.1242 34 30.6269V17.8769C34 17.3796 33.8025 16.9027 33.4508 16.5511C33.0992 16.1994 32.6223 16.0019 32.125 16.0019ZM24.13 14.4119C24.9711 13.714 26.0375 13.3461 27.13 13.3769C27.4682 13.3769 27.7925 13.5112 28.0316 13.7503C28.2707 13.9894 28.405 14.3137 28.405 14.6519C28.405 14.99 28.2707 15.3144 28.0316 15.5535C27.7925 15.7926 27.4682 15.9269 27.13 15.9269H23.11C23.3077 15.3394 23.6601 14.8161 24.13 14.4119ZM16.855 13.3769C17.9475 13.3461 19.0139 13.714 19.855 14.4119C20.3227 14.812 20.6749 15.3299 20.875 15.9119H16.855C16.5168 15.9119 16.1925 15.7776 15.9534 15.5385C15.7143 15.2994 15.58 14.975 15.58 14.6369C15.58 14.2987 15.7143 13.9744 15.9534 13.7353C16.1925 13.4962 16.5168 13.3619 16.855 13.3619V13.3769ZM11.875 17.8769H32.125V19.7519H11.875V17.8769ZM11.875 30.6269V23.5019H32.125V30.6269H11.875Z" fill="black"/>
                                </svg>
                            </span>
                            <div>
                                <!-- <h5>1 New Request</h5> -->
                                <!-- <h5 v-if="popupPartnersManagement">{{ popupPartnersManagement.property.title }}</h5> -->
                                <h5>Maintenance Request Pending</h5>
                                <div class="time-bouund">
                                    <!-- <h4 v-if="timeLeftP > 0">{{formattedTimeParnter}} <span>Time Left</span></h4> -->
                                    <!-- <h4 v-else>00:00:00</h4> -->
                                    <h4>12:00 <span>Time Left</span></h4>
                                    <h6>Your have an unattended maintenance request from your tenant</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="responseButton">
                            <button class="btn accept">Accept</button>
                            <button class="btn outlinedBtnn">Reject</button>
                            <!-- <button class="btn accept" ref="btn1" :disbaled="btnLoading.btn1" @click="respondToManagementAssignment('accept', popupPartnersManagement.id, 'btn1')">
                                <span v-if="!btnLoading.btn1">Accept</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                            <button class="btn reject" ref="btn2" :disbaled="btnLoading.btn2" @click="respondToManagementAssignment('ignore', popupPartnersManagement.id, 'btn2')">
                                <span v-if="!btnLoading.btn2">Reject</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>


            <div class="pop-holder2 d-none" >
                <div class="row">
                    <div class="col-md-8">
                        <!-- <h6>1 New Property Assigned</h6> -->
                        <div class="left-hand">
                            <!-- <img src="../assets/icons/request.svg" alt="request"> -->
                            <span>
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.02" y="0.02" width="43.96" height="43.96" rx="21.98" fill="white"/>
                                    <rect x="0.02" y="0.02" width="43.96" height="43.96" rx="21.98" stroke="#E5E7EB" stroke-width="0.04"/>
                                    <path d="M18 19H26M18 23H24M28 14C28.7956 14 29.5587 14.3161 30.1213 14.8787C30.6839 15.4413 31 16.2044 31 17V25C31 25.7956 30.6839 26.5587 30.1213 27.1213C29.5587 27.6839 28.7956 28 28 28H23L18 31V28H16C15.2044 28 14.4413 27.6839 13.8787 27.1213C13.3161 26.5587 13 25.7956 13 25V17C13 16.2044 13.3161 15.4413 13.8787 14.8787C14.4413 14.3161 15.2044 14 16 14H28Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <div>
                                <!-- <h5>1 New Request</h5> -->
                                <!-- <h5 v-if="popupPartnersManagement">{{ popupPartnersManagement.property.title }}</h5> -->
                                <h5>24 Pending message from tenant</h5>
                                <div class="time-bouund">
                                    <!-- <h4 v-if="timeLeftP > 0">{{formattedTimeParnter}} <span>Time Left</span></h4> -->
                                    <!-- <h4 v-else>00:00:00</h4> -->
                                    <!-- <h4>12:00 <span>Time Left</span></h4> -->
                                    <h6>Your have an unattended message from your tenant</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="responseButton">
                            <button class="btn accept">Accept</button>
                            <button class="btn outlinedBtnn">Reject</button>
                            <!-- <button class="btn accept" ref="btn1" :disbaled="btnLoading.btn1" @click="respondToManagementAssignment('accept', popupPartnersManagement.id, 'btn1')">
                                <span v-if="!btnLoading.btn1">Accept</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                            <button class="btn reject" ref="btn2" :disbaled="btnLoading.btn2" @click="respondToManagementAssignment('ignore', popupPartnersManagement.id, 'btn2')">
                                <span v-if="!btnLoading.btn2">Reject</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="loading">
                    <PageLoader></PageLoader>
                </div>
            <div v-else>
                <div class="white-bg mb-3 mt-3">
                    <div class="flex-button-section mb-4">
                        <div class="">
                            <h4 class="headings">Tenant Information</h4>
                            <!-- d-none d-sm-block Hide on small devices -->
                        </div>
                        <div>
                            <button class="btn sheltaBtn">Request Rent</button>
                        </div>
                    </div>

                    <div class="base-buttons hide-scrollbar">
                        <button class="btn plainButton" :class="[baseBtn == 'Personal' ? 'base-buttons-active' : '']" @click="baseBtn = 'Personal'">Personal/Property</button>
                        <button class="btn plainButton" :class="[baseBtn == 'Contacts' ? 'base-buttons-active' : '']" @click="baseBtn = 'Contacts'">Contacts/Emergency</button>
                        <!-- <button class="btn plainButton" :class="[baseBtn == 'Emergency' ? 'base-buttons-active' : '']" @click="baseBtn = 'Emergency'">Emergency contant</button> -->
                        <button class="btn plainButton" :class="[baseBtn == 'Documents' ? 'base-buttons-active' : '']" @click="baseBtn = 'Documents'">Documents</button>
                    </div>
                </div>

                <div v-if="baseBtn == 'Personal'">
                    <div class="white-bg mt-1">
                        <h5 class="headings">Personal details of tenant</h5>
                        <div class="details-holder-tenant">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="row pdt" v-if="tenantsdetails">
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>First name</h5>
                                                <h6>{{tenantsdetails.user_object.firstname}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Last name</h5>
                                                <h6>{{tenantsdetails.user_object.lastname}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Other name</h5>
                                                <h6>{{tenantsdetails.user_object.othernames ? tenantsdetails.user_object.othernames : '--'}} </h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>NIN</h5>
                                                <h6>{{ tenantsdetails.user_object.nin ? tenantsdetails.user_object.nin : '--' }}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Phone Number</h5>
                                                <h6>{{ tenantsdetails.user_object.phone }} </h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Email</h5>
                                                <h6>{{ tenantsdetails.user_object.email}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" v-if="tenantsdetails.user_object">
                                    <div class="profile-picture"> 
                                        <img v-if="tenantsdetails.user_object.passportfile != null" :src="tenantsdetails.user_object.passportfile" alt="profile">
                                        <img v-else src="../assets/icons/profile-icon.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="btn-right">
                                <button class="btn outlinedBtnn">Edit tenant info</button>
                            </div>
                        </div>
                    </div>

                    <div class="white-bg mt-1" v-if="propertyDetails">
                        <h5 class="headings">Personal details of tenant</h5>
                        <div class="details-holder-tenant">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="row pdt">
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Rent type</h5>
                                                <h6>{{ outterDetails.rent_type }}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Property title</h5>
                                                <h6>{{ propertyDetails.title }}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Property type</h5>
                                                <h6 v-if="propertyDetails.type">{{ propertyDetails.type.type }}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Property subtype</h5>
                                                <h6 v-if="propertyDetails.subtype">{{propertyDetails.subtype.subtype}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Unit</h5>
                                                <h6>{{ propertyDetails.nomenclature_serial }}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Rent Status</h5>
                                                <h6 style="text-transform: capitalize;">{{outterDetails.rent_status}} </h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>Rent due date</h5>
                                                <h6>{{outterDetails.rent_due_date | moment}} </h6>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            <div>
                                                <h5>date of first rent payment</h5>
                                                <h6>{{outterDetails.first_payment_date | moment}} </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-2">
                                    <div class="profile-picture">
                                        <img src="../assets/icons/profile-icon.svg" alt="">
                                    </div>
                                </div> -->
                            </div>
                            <!-- <div class="btn-right">
                                <button class="btn outlinedBtnn">Edit tenant info</button>
                            </div> -->
                        </div>
                    </div>
                </div>


                <div v-if="baseBtn == 'Contacts'">
                    <div class="white-bg mt-1">
                        <h5 class="headings">Next of kin's contact details of tenant </h5>
                        <div class="details-holder-tenant">
                            <div v-if="tenantsdetails.nextofkin.fullname == null && tenantsdetails.nextofkin.email == null && tenantsdetails.nextofkin.phone == null" class="empty-state mt-5 mb-5">
                                <img src="../assets/icons/emptycan-state.svg" alt="empty">
                                <h5>No available data</h5>
                            </div>
                            <div v-else class="row">
                                <div class="col-md-10">
                                    <div class="row pdt">
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Fullname</h5>
                                                <h6>{{tenantsdetails.nextofkin.fullname ? tenantsdetails.nextofkin.fullname : '--'}}</h6>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Last name</h5>
                                                <h6>Ronyem</h6>
                                            </div>
                                        </div> -->
                                        <!-- <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Other name</h5>
                                                <h6>Amos </h6>
                                            </div>
                                        </div> -->
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Email Address</h5>
                                                <h6>{{tenantsdetails.nextofkin.email ? tenantsdetails.nextofkin.email : '--'}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Phone Number</h5>
                                                <h6>{{tenantsdetails.nextofkin.phone ? tenantsdetails.nextofkin.phone : '--'}} </h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Relationship Type</h5>
                                                <h6>{{tenantsdetails.nextofkin.relationship ? tenantsdetails.nextofkin.relationship : '--'}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Address</h5>
                                                <h6>{{tenantsdetails.nextofkin.address ? tenantsdetails.nextofkin.address : '--'}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-2">
                                    <div class="profile-picture">
                                        <img src="../assets/icons/profile-icon.svg" alt="">
                                    </div>
                                </div> -->
                            </div>
                            <!-- <div class="btn-right">
                                <button class="btn outlinedBtnn">Edit tenant info</button>
                            </div> -->
                        </div>
                    </div>

                    <div class="white-bg mt-1">
                        <h5 class="headings">Emergency contact details of tenant </h5>
                        <div class="details-holder-tenant">
                            <div v-if="tenantsdetails.emergency_details.fullname == null && tenantsdetails.emergency_details.email == null && tenantsdetails.emergency_details.phone == null" class="empty-state mt-5 mb-5">
                                <img src="../assets/icons/emptycan-state.svg" alt="empty">
                                <h5>No available data</h5>
                            </div>
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="row pdt">
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Fullname</h5>
                                                <h6>{{tenantsdetails.emergency_details.fullname ? tenantsdetails.emergency_details.fullname : '--'}}</h6>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Last name</h5>
                                                <h6>Ronyem</h6>
                                            </div>
                                        </div> -->
                                        <!-- <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Other name</h5>
                                                <h6>Amos </h6>
                                            </div>
                                        </div> -->
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Email Address</h5>
                                                <h6>{{tenantsdetails.emergency_details.email ?  tenantsdetails.emergency_details.email : '--' }}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Phone Number</h5>
                                                <h6> {{tenantsdetails.emergency_details.phone ? tenantsdetails.emergency_details.phone : '--'}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Relationship Type</h5>
                                                <h6>{{tenantsdetails.emergency_details.relationship ? tenantsdetails.emergency_details.relationship : '--'}}</h6>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-6">
                                            <div>
                                                <h5>Address</h5>
                                                <h6>{{tenantsdetails.emergency_details.address ? tenantsdetails.emergency_details.address : '--'}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-2">
                                    <div class="profile-picture">
                                        <img src="../assets/icons/profile-icon.svg" alt="">
                                    </div>
                                </div> -->
                            </div>
                            <!-- <div class="btn-right">
                                <button class="btn outlinedBtnn">Edit tenant info</button>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div v-if="baseBtn == 'Documents'">
                    <div class="white-bg mt-1">
                        <h5 class="headings">Tenant Documents </h5>
                        <div class="documents-holder">
                            <div class="row">
                                <div class="col-md-4">
                                    <div>
                                        <!-- <img src="" alt=""> -->
                                        <div class="image-fit-check">
                                            <img src="../assets/images/landlord-tenant-agreement.svg" alt="agreement">
                                        </div>
                                        <div class="doc-body">
                                            <div class="doc-body-header-title">
                                                <h6>Tenancy agreement</h6>
                                                <button class="btn navyblueBtnPills">View Doc.</button>
                                            </div>
                                            <div  class="doc-body-header-subtitle">
                                                <h5>Uploaded by Landlord</h5>
                                                <h5>20-5-2025</h5>
                                            </div>
                                            <div class="text-right mt-4">
                                                <span style="cursor: pointer;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.47068 14.0206L12.666 7.82524L9.72335 4.88257L3.52802 11.0779C3.44272 11.1633 3.38214 11.2702 3.35268 11.3872L2.66602 14.8826L6.16068 14.1959C6.27802 14.1666 6.38535 14.1059 6.47068 14.0206ZM14.666 5.82524C14.916 5.5752 15.0564 5.23612 15.0564 4.88257C15.0564 4.52902 14.916 4.18994 14.666 3.9399L13.6087 2.88257C13.3586 2.63261 13.0196 2.49219 12.666 2.49219C12.3125 2.49219 11.9734 2.63261 11.7233 2.88257L10.666 3.9399L13.6087 6.88257L14.666 5.82524Z" fill="#1F2937"/>
                                                    </svg>
                                                </span>
                                                <span class="mr-3 ml-3" style="cursor: pointer;">
                                                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.6654 14.2148L13.9987 10.0482H11.4987V4.21484H9.83203V10.0482H7.33203L10.6654 14.2148Z" fill="#000077"/>
                                                        <path d="M17.332 15.8841H3.9987V10.0508H2.33203V15.8841C2.33203 16.8033 3.07953 17.5508 3.9987 17.5508H17.332C18.2512 17.5508 18.9987 16.8033 18.9987 15.8841V10.0508H17.332V15.8841Z" fill="#000077"/>
                                                    </svg>
                                                </span>
                                                <span style="cursor: pointer;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.66602 5.54818H3.99935V14.2148C3.99935 14.5685 4.13982 14.9076 4.38987 15.1577C4.63992 15.4077 4.97906 15.5482 5.33268 15.5482H11.9993C12.353 15.5482 12.6921 15.4077 12.9422 15.1577C13.1922 14.9076 13.3327 14.5685 13.3327 14.2148V5.54818H4.66602ZM7.33268 13.5482H5.99935V7.54818H7.33268V13.5482ZM11.3327 13.5482H9.99935V7.54818H11.3327V13.5482ZM11.7447 3.54818L10.666 2.21484H6.66602L5.58735 3.54818H2.66602V4.88151H14.666V3.54818H11.7447Z" fill="#F87171"/>
                                                    </svg>

                                                </span>
                                            </div>
                                        </div>

                                        
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div>
                                        <!-- <img src="" alt=""> -->
                                        <div class="image-fit-check">
                                            <img src="../assets/images/landlord-tenant-picture.svg" alt="picture">
                                        </div>
                                        <div class="doc-body">
                                            <div class="doc-body-header-title">
                                                <h6>Tenant Picture</h6>
                                                <button class="btn navyblueBtnPills">View Picture</button>
                                            </div>
                                            <div  class="doc-body-header-subtitle">
                                                <h5>Uploaded by FMC</h5>
                                                <h5>20-5-2025</h5>
                                            </div>

                                            <div class="text-right mt-4">
                                                <span style="cursor: pointer;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.47068 14.0206L12.666 7.82524L9.72335 4.88257L3.52802 11.0779C3.44272 11.1633 3.38214 11.2702 3.35268 11.3872L2.66602 14.8826L6.16068 14.1959C6.27802 14.1666 6.38535 14.1059 6.47068 14.0206ZM14.666 5.82524C14.916 5.5752 15.0564 5.23612 15.0564 4.88257C15.0564 4.52902 14.916 4.18994 14.666 3.9399L13.6087 2.88257C13.3586 2.63261 13.0196 2.49219 12.666 2.49219C12.3125 2.49219 11.9734 2.63261 11.7233 2.88257L10.666 3.9399L13.6087 6.88257L14.666 5.82524Z" fill="#1F2937"/>
                                                    </svg>
                                                </span>
                                                <span class="mr-3 ml-3" style="cursor: pointer;">
                                                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.6654 14.2148L13.9987 10.0482H11.4987V4.21484H9.83203V10.0482H7.33203L10.6654 14.2148Z" fill="#000077"/>
                                                        <path d="M17.332 15.8841H3.9987V10.0508H2.33203V15.8841C2.33203 16.8033 3.07953 17.5508 3.9987 17.5508H17.332C18.2512 17.5508 18.9987 16.8033 18.9987 15.8841V10.0508H17.332V15.8841Z" fill="#000077"/>
                                                    </svg>
                                                </span>
                                                <span style="cursor: pointer;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.66602 5.54818H3.99935V14.2148C3.99935 14.5685 4.13982 14.9076 4.38987 15.1577C4.63992 15.4077 4.97906 15.5482 5.33268 15.5482H11.9993C12.353 15.5482 12.6921 15.4077 12.9422 15.1577C13.1922 14.9076 13.3327 14.5685 13.3327 14.2148V5.54818H4.66602ZM7.33268 13.5482H5.99935V7.54818H7.33268V13.5482ZM11.3327 13.5482H9.99935V7.54818H11.3327V13.5482ZM11.7447 3.54818L10.666 2.21484H6.66602L5.58735 3.54818H2.66602V4.88151H14.666V3.54818H11.7447Z" fill="#F87171"/>
                                                    </svg>

                                                </span>
                                            </div>
                                        </div>

                            
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div>
                                        <!-- <img src="" alt=""> -->
                                        <div class="image-fit-check">
                                            <img src="../assets/images/renovation-landlord.svg" alt="maintenance">
                                        </div>
                                        <div class="doc-body">
                                            <div class="doc-body-header-title">
                                                <h6>Maintenance image</h6>
                                                <button class="btn navyblueBtnPills">View Image</button>
                                            </div>
                                            <div  class="doc-body-header-subtitle">
                                                <h5>Uploaded by Tenant</h5>
                                                <h5>20-5-2025</h5>
                                            </div>

                                            <div class="text-right mt-4">
                                                <span style="cursor: pointer;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.47068 14.0206L12.666 7.82524L9.72335 4.88257L3.52802 11.0779C3.44272 11.1633 3.38214 11.2702 3.35268 11.3872L2.66602 14.8826L6.16068 14.1959C6.27802 14.1666 6.38535 14.1059 6.47068 14.0206ZM14.666 5.82524C14.916 5.5752 15.0564 5.23612 15.0564 4.88257C15.0564 4.52902 14.916 4.18994 14.666 3.9399L13.6087 2.88257C13.3586 2.63261 13.0196 2.49219 12.666 2.49219C12.3125 2.49219 11.9734 2.63261 11.7233 2.88257L10.666 3.9399L13.6087 6.88257L14.666 5.82524Z" fill="#1F2937"/>
                                                    </svg>
                                                </span>
                                                <span class="mr-3 ml-3" style="cursor: pointer;">
                                                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.6654 14.2148L13.9987 10.0482H11.4987V4.21484H9.83203V10.0482H7.33203L10.6654 14.2148Z" fill="#000077"/>
                                                        <path d="M17.332 15.8841H3.9987V10.0508H2.33203V15.8841C2.33203 16.8033 3.07953 17.5508 3.9987 17.5508H17.332C18.2512 17.5508 18.9987 16.8033 18.9987 15.8841V10.0508H17.332V15.8841Z" fill="#000077"/>
                                                    </svg>
                                                </span>
                                                <span style="cursor: pointer;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.66602 5.54818H3.99935V14.2148C3.99935 14.5685 4.13982 14.9076 4.38987 15.1577C4.63992 15.4077 4.97906 15.5482 5.33268 15.5482H11.9993C12.353 15.5482 12.6921 15.4077 12.9422 15.1577C13.1922 14.9076 13.3327 14.5685 13.3327 14.2148V5.54818H4.66602ZM7.33268 13.5482H5.99935V7.54818H7.33268V13.5482ZM11.3327 13.5482H9.99935V7.54818H11.3327V13.5482ZM11.7447 3.54818L10.666 2.21484H6.66602L5.58735 3.54818H2.66602V4.88151H14.666V3.54818H11.7447Z" fill="#F87171"/>
                                                    </svg>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="white-bg mt-3 mb-5">
                    <h5 class="headings">Tenant Activities</h5>
                    <div class="table-holder" style="padding: 0;">
                        <div class="table-responsive tableList">
                            <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                                <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Type</th>
                                        <th scope="col">Date</th>
                                        <!-- <th scope="col">Time</th> -->
                                        <th scope="col">Amount</th>
                                        <!-- <th scope="col">Status</th> -->
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- v-for="(item, index) in landlords"
                                        :key="index" -->
                                    <tr v-for="(item, index) in teanatActivities"
                                        :key="index">
                                        <td>{{item.is_it_rent == 'YES' ? 'Rent': 'Others'}}</td>
                                        <td>{{ item.date | moment }}</td>
                                        <!-- <td>9:00 AM</td> -->
                                        <td>₦{{ Number(item.amount).toLocaleString() }} </td>
                                        <!-- <td>Successful</td> -->
                                        <td>
                                            <span>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.9375 6.86422C14.205 4.14172 11.67 2.57422 9 2.57422C7.665 2.57422 6.3675 2.96422 5.1825 3.69172C3.9975 4.42672 2.9325 5.49922 2.0625 6.86422C1.3125 8.04172 1.3125 9.95422 2.0625 11.1317C3.795 13.8617 6.33 15.4217 9 15.4217C10.335 15.4217 11.6325 15.0317 12.8175 14.3042C14.0025 13.5692 15.0675 12.4967 15.9375 11.1317C16.6875 9.96172 16.6875 8.04172 15.9375 6.86422ZM9 12.0317C7.32 12.0317 5.97 10.6742 5.97 9.00172C5.97 7.32922 7.32 5.97172 9 5.97172C10.68 5.97172 12.03 7.32922 12.03 9.00172C12.03 10.6742 10.68 12.0317 9 12.0317Z" fill="#001C82"/>
                                                    <path d="M9.00078 6.85547C7.82328 6.85547 6.86328 7.81547 6.86328 9.00047C6.86328 10.178 7.82328 11.138 9.00078 11.138C10.1783 11.138 11.1458 10.178 11.1458 9.00047C11.1458 7.82297 10.1783 6.85547 9.00078 6.85547Z" fill="#4A4A4A"/>
                                                </svg>
                                            </span>
                                            <span class="ml-3">
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.53025 14.7819L13.5 7.81218L10.1895 4.50168L3.21975 11.4714C3.1238 11.5675 3.05564 11.6878 3.0225 11.8194L2.25 15.7517L6.1815 14.9792C6.3135 14.9462 6.43425 14.8779 6.53025 14.7819ZM15.75 5.56218C16.0312 5.28089 16.1892 4.89943 16.1892 4.50168C16.1892 4.10393 16.0312 3.72247 15.75 3.44118L14.5605 2.25168C14.2792 1.97047 13.8977 1.8125 13.5 1.8125C13.1023 1.8125 12.7208 1.97047 12.4395 2.25168L11.25 3.44118L14.5605 6.75168L15.75 5.56218Z" fill="#333333"/>
                                                </svg>

                                            </span>
                                        </td>
                                        <!-- <td></td> -->
                                        <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                    </tr>                          
                                </tbody>
                            </table>
                            <div v-if="teanatActivities.length == 0" class="empty-state mt-5 mb-5">
                                <img src="../assets/icons/emptycan-state.svg" alt="empty">
                                <h5>No available data</h5>
                            </div>
                            <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                                <EmptyState :emptyData="emptyDataObject2" />
                            </div> -->
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/styles/custom.scss';
import PageLoader from "./PageLoader.vue";
import { Service } from "../store/service";
const Api = new Service();
import moment from "moment";

export default {
    name: "LandlordProperties2",
    components: {
        PageLoader
    },
    data() {
        return {
            loading: false,
            baseBtn: 'Personal',
            teanatId: this.$route.params.id,
            tenantsdetails: "",
            teanatActivities: [],
            propertyDetails: {},
            outterDetails: ""

        }
    },
    watch: {
        '$route.params.id'(routeId) {
            this.teanatId = routeId
        }
    },
    mounted() {
        this.fetchTenantDetails();
    },
    methods: {
        // scrollToSection() {
        //     this.$refs.mySection.scrollIntoView({ behavior: 'smooth' });
        // },
        navigateTo(route) {
            return this.$router.push({
                path: route
            });
        },
        async fetchTenantDetails() {
            this.loading = true;
        // this.loader = true;
        try {
            await Api.getRequest(`landlord-tenant-details-by-tenant-id/${this.teanatId}`)
            .then(res => {
                // if (res.data.error) {
                //   this.hideDiv = false;
                // }
                this.loading = false;
                // console.log("Tenants deatils", res);
                if (res.data.success) {
                this.tenantsdetails = res.data.tenant.user;
                this.teanatActivities =  res.data.tenant_activities;
                this.propertyDetails = res.data.property;
                this.outterDetails = res.data;
                }
            })
            .catch(err => {
                // console.log(err);
                this.loading = false;
                // this.loader = false;
            });
            } finally {
                // console.log("Closed connection");
            }
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY");
        }
    }
}
</script>


<style scoped lang="scss">


.base-buttons {
    display: flex;
    margin-bottom: -26px;
    overflow: scroll;
    white-space: nowrap;
}
.base-buttons-active {
    background: #e5e5e5;
    color: #333333;
}

.details-holder-tenant {
    margin-top: 30px;
}
.pdt {
    h5 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 16px;
        line-height: 23px;
        color: #333333;
        text-align: left;
        word-wrap: break-word;
        margin-bottom: 22px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 23px;
        color: #4B5563;
        text-align: left;
        word-wrap: break-word;
        margin-bottom: 22px;
    }
}

.btn-right {
    text-align: right;
    margin-top: 20px;
}

.profile-picture {
    width: 100px;
    height: 93px;
    img {
        width: 100px;
        height: 93px;
        object-fit: cover;
    }
}
.doc-body-header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h6 {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 28px;
        color: #374151;
    }


}

.doc-body-header-subtitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 30px;
        color: #374151;
    }
}
.documents-holder {
    margin-top: 30px;
}
.image-fit-check {
    img {
        background-size: cover;
        width: 100%;
    }
}

.doc-body {
    margin-bottom: 20px;
    border: 1px solid #EAECF0;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    padding: 15px;
    // padding-top: 0;
}



// For top popup starts

.pop-holder {
    background: #FFF7ED;
    padding: 16px;
    margin-bottom: 15px;
}
.pop-holder2 {
    background: #D1DBFF;
    padding: 16px;
    margin-bottom: 15px;
}

.left-hand {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: #2B3352;
        text-align: left;
    }
}

.time-bouund {
    display: flex;
    align-items: center;
    gap: 10px;
    h4 {
        width: fit-content;
        background: #ffffff;
        padding: 2px 12px;
        border-radius: 5px;
        font-family: Lato;
        font-weight: 700;
        font-size: 21px;
        line-height: 32px;
        color: #FB3748;
        display: flex;
        gap: 10px;
        text-align: left;
        white-space: nowrap;
        span {
            color: #92400E;
            font-size: 12px;
        }
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        color: #555C74;
        text-align: left;
    }
}


.responseButton {
    text-align: right;
    margin-top: 18px;
    button {
        min-height: 42px;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        outline: 0;
        box-shadow: none;
    }
    .accept {
        color: #ffffff;
        background: #0033EA;
        margin-right: 10px;
    }
    .reject {
        background: #ffffff;
        border: 1px solid #0033EA;
        color: #0033EA;
    }
}

@media screen and (max-width: 599px) {
    .time-bouund {
        display: block;
    }
    .responseButton {
        text-align: center;
    }
}
// For top popup ends

</style>